import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { Card, CardContent } from "@/components/ui/card";

// Legal information - centralized
export const LEGAL_INFO = {
  name: "KOTTEYA WATTAGE Sasmithe",
  status: "Auto-entrepreneur",
  siret: "83451322800017",
  address: "14 Ter Avenue Mathurin Moreau, Esc E, 75019 Paris, France",
  email: "sasmitha@hotmail.fr",
  website: "sasmithe-traductions.fr",
  hostName: "Vercel Inc.",
  hostAddress: "440 N Barranca Ave #4133, Covina, CA 91723, USA",
};

// CGV Page
export const CGVPage = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Terms and Conditions of Sale",
      lastUpdate: "Last updated: January 2026",
      sections: [
        {
          title: "1. Scope",
          content: `These Terms and Conditions of Sale (T&Cs) govern all translation and interpreting services provided by ${LEGAL_INFO.name}, trading as "Sasmithe Traductions", Auto-entrepreneur registered under SIRET ${LEGAL_INFO.siret}.`
        },
        {
          title: "2. Services",
          content: `Sasmithe Traductions offers the following services:
• Video interpreting (French ↔ Sinhala)
• In-person interpreting
• Document translation

All services are provided between French and Sinhala languages.`
        },
        {
          title: "3. Pricing and Payment",
          content: `• Prices are displayed in Euros (€) and are inclusive of all taxes (Auto-entrepreneur VAT exempt under Article 293 B of the French Tax Code)
• Payment is required at the time of booking
• Accepted payment methods: Credit card (via Stripe), PayPal
• A confirmation email is sent upon successful payment`
        },
        {
          title: "4. Booking and Cancellation Policy",
          content: `Cancellation conditions for interpreting services:
• Cancellation 45 days or more before the appointment: 100% refund
• Cancellation less than 45 days before the appointment: 50% refund
• Cancellation less than 24 hours before or no-show: No refund

For document translation:
• Cancellation before work begins: 100% refund
• Once translation work has started: No refund

To cancel, please contact us at ${LEGAL_INFO.email}`
        },
        {
          title: "5. Right of Withdrawal",
          content: `In accordance with Article L221-28 of the French Consumer Code, the right of withdrawal does not apply to services fully performed before the end of the withdrawal period with the consumer's prior express agreement and acknowledgment that they will lose their right of withdrawal.

By booking a service, you expressly agree that the service may be performed before the end of the 14-day withdrawal period and acknowledge that you will lose your right of withdrawal once the service has been fully performed.`
        },
        {
          title: "6. Confidentiality",
          content: `Sasmithe Traductions guarantees the strict confidentiality of all documents and information shared by clients. No information will be disclosed to third parties without prior written consent.`
        },
        {
          title: "7. Liability",
          content: `Sasmithe Traductions commits to providing high-quality services. However, liability is limited to the amount paid for the service. Sasmithe Traductions cannot be held liable for indirect damages.`
        },
        {
          title: "8. Intellectual Property",
          content: `Upon full payment, the client receives full rights to use the translated documents. Sasmithe Traductions retains the right to use anonymized excerpts for professional demonstration purposes.`
        },
        {
          title: "9. Dispute Resolution",
          content: `In case of dispute, an amicable solution will be sought first. If no agreement is reached, disputes will be subject to French law and the jurisdiction of Paris courts.

For consumer mediation, you may contact: CM2C - 14 rue Saint Jean 75017 Paris - www.cm2c.net`
        },
        {
          title: "10. Contact",
          content: `${LEGAL_INFO.name}
${LEGAL_INFO.address}
Email: ${LEGAL_INFO.email}`
        }
      ]
    },
    fr: {
      title: "Conditions Générales de Vente",
      lastUpdate: "Dernière mise à jour : Janvier 2026",
      sections: [
        {
          title: "1. Champ d'application",
          content: `Les présentes Conditions Générales de Vente (CGV) régissent l'ensemble des prestations de traduction et d'interprétation fournies par ${LEGAL_INFO.name}, exerçant sous le nom commercial "Sasmithe Traductions", Auto-entrepreneur immatriculé sous le SIRET ${LEGAL_INFO.siret}.`
        },
        {
          title: "2. Services",
          content: `Sasmithe Traductions propose les services suivants :
• Interprétation vidéo (Français ↔ Cinghalais)
• Interprétation en personne
• Traduction de documents

Tous les services sont fournis entre le français et le cinghalais.`
        },
        {
          title: "3. Tarifs et Paiement",
          content: `• Les prix sont affichés en Euros (€) et sont nets de taxes (Auto-entrepreneur non assujetti à la TVA selon l'article 293 B du CGI)
• Le paiement est requis au moment de la réservation
• Moyens de paiement acceptés : Carte bancaire (via Stripe), PayPal
• Un email de confirmation est envoyé après paiement réussi`
        },
        {
          title: "4. Réservation et Conditions d'Annulation",
          content: `Conditions d'annulation pour les services d'interprétation :
• Annulation 45 jours ou plus avant le rendez-vous : Remboursement à 100%
• Annulation moins de 45 jours avant le rendez-vous : Remboursement à 50%
• Annulation moins de 24 heures avant ou absence : Aucun remboursement

Pour la traduction de documents :
• Annulation avant le début du travail : Remboursement à 100%
• Une fois le travail de traduction commencé : Aucun remboursement

Pour annuler, veuillez nous contacter à ${LEGAL_INFO.email}`
        },
        {
          title: "5. Droit de Rétractation",
          content: `Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux services pleinement exécutés avant la fin du délai de rétractation avec l'accord préalable exprès du consommateur et reconnaissance de la perte de son droit de rétractation.

En réservant un service, vous acceptez expressément que le service puisse être exécuté avant la fin du délai de rétractation de 14 jours et reconnaissez que vous perdrez votre droit de rétractation une fois le service pleinement exécuté.`
        },
        {
          title: "6. Confidentialité",
          content: `Sasmithe Traductions garantit la stricte confidentialité de tous les documents et informations partagés par les clients. Aucune information ne sera divulguée à des tiers sans consentement écrit préalable.`
        },
        {
          title: "7. Responsabilité",
          content: `Sasmithe Traductions s'engage à fournir des services de haute qualité. Toutefois, la responsabilité est limitée au montant payé pour le service. Sasmithe Traductions ne peut être tenu responsable des dommages indirects.`
        },
        {
          title: "8. Propriété Intellectuelle",
          content: `Après paiement intégral, le client reçoit tous les droits d'utilisation des documents traduits. Sasmithe Traductions conserve le droit d'utiliser des extraits anonymisés à des fins de démonstration professionnelle.`
        },
        {
          title: "9. Règlement des Litiges",
          content: `En cas de litige, une solution amiable sera recherchée en priorité. À défaut d'accord, les litiges seront soumis au droit français et à la compétence des tribunaux de Paris.

Pour la médiation de la consommation, vous pouvez contacter : CM2C - 14 rue Saint Jean 75017 Paris - www.cm2c.net`
        },
        {
          title: "10. Contact",
          content: `${LEGAL_INFO.name}
${LEGAL_INFO.address}
Email : ${LEGAL_INFO.email}`
        }
      ]
    },
    si: {
      title: "විකුණුම් නියමයන් සහ කොන්දේසි",
      lastUpdate: "අවසන් යාවත්කාලීනය: ජනවාරි 2026",
      sections: [
        {
          title: "1. විෂය පථය",
          content: `මෙම විකුණුම් නියමයන් සහ කොන්දේසි ${LEGAL_INFO.name} විසින් "Sasmithe Traductions" යන නමින් සපයන සියලුම පරිවර්තන සහ අර්ථකථන සේවාවන් නියාමනය කරයි. SIRET ${LEGAL_INFO.siret} යටතේ ලියාපදිංචි Auto-entrepreneur.`
        },
        {
          title: "2. සේවාවන්",
          content: `Sasmithe Traductions පහත සේවාවන් සපයයි:
• වීඩියෝ අර්ථකථනය (ප්‍රංශ ↔ සිංහල)
• පුද්ගලික අර්ථකථනය
• ලේඛන පරිවර්තනය

සියලුම සේවාවන් ප්‍රංශ සහ සිංහල භාෂා අතර සපයනු ලැබේ.`
        },
        {
          title: "3. මිල සහ ගෙවීම්",
          content: `• මිල ගණන් යුරෝ (€) වලින් පෙන්වා ඇත
• වෙන්කිරීමේදී ගෙවීම අවශ්‍යයි
• පිළිගත් ගෙවීම් ක්‍රම: ක්‍රෙඩිට් කාඩ් (Stripe හරහා), PayPal
• සාර්ථක ගෙවීමෙන් පසු තහවුරු කිරීමේ ඊමේල් එවනු ලැබේ`
        },
        {
          title: "4. වෙන්කිරීම් සහ අවලංගු කිරීමේ ප්‍රතිපත්තිය",
          content: `අර්ථකථන සේවා සඳහා අවලංගු කිරීමේ කොන්දේසි:
• හමුවීමට දින 45කට හෝ ඊට පෙර අවලංගු කිරීම: 100% මුදල් ආපසු
• දින 45කට අඩු කාලයකට පෙර අවලංගු කිරීම: 50% මුදල් ආපසු
• පැය 24කට අඩු කාලයකට පෙර හෝ නොපැමිණීම: මුදල් ආපසු නැත

ලේඛන පරිවර්තනය සඳහා:
• වැඩ ආරම්භ කිරීමට පෙර අවලංගු කිරීම: 100% මුදල් ආපසු
• පරිවර්තන කටයුතු ආරම්භ වූ පසු: මුදල් ආපසු නැත

අවලංගු කිරීමට, කරුණාකර ${LEGAL_INFO.email} වෙත අමතන්න`
        },
        {
          title: "5. ඉවත්වීමේ අයිතිය",
          content: `ප්‍රංශ පාරිභෝගික නීතිය අනුව, පාරිභෝගිකයාගේ පූර්ව ප්‍රකාශිත එකඟතාවයෙන් ඉවත්වීමේ කාලය අවසන් වීමට පෙර සම්පූර්ණයෙන් ඉටු කරන ලද සේවාවන් සඳහා ඉවත්වීමේ අයිතිය අදාළ නොවේ.

සේවාවක් වෙන්කරවා ගැනීමෙන්, දින 14 ඉවත්වීමේ කාලය අවසන් වීමට පෙර සේවාව ඉටු කළ හැකි බවට ඔබ ප්‍රකාශිතව එකඟ වන අතර සේවාව සම්පූර්ණයෙන් ඉටු කළ පසු ඔබේ ඉවත්වීමේ අයිතිය අහිමි වන බව පිළිගනී.`
        },
        {
          title: "6. රහස්‍යභාවය",
          content: `Sasmithe Traductions සේවාදායකයින් විසින් බෙදාගන්නා සියලුම ලේඛන සහ තොරතුරුවල දැඩි රහස්‍යභාවය සහතික කරයි. පූර්ව ලිඛිත එකඟතාවයකින් තොරව කිසිදු තොරතුරක් තෙවන පාර්ශ්වයකට හෙළි නොකෙරේ.`
        },
        {
          title: "7. වගකීම",
          content: `Sasmithe Traductions උසස් තත්ත්වයේ සේවාවන් සැපයීමට කැපවී සිටී. කෙසේ වෙතත්, වගකීම සේවාව සඳහා ගෙවන ලද මුදලට සීමා වේ.`
        },
        {
          title: "8. බුද්ධිමය දේපළ",
          content: `සම්පූර්ණ ගෙවීමෙන් පසු, සේවාදායකයා පරිවර්තිත ලේඛන භාවිතා කිරීමට සම්පූර්ණ අයිතිවාසිකම් ලබා ගනී.`
        },
        {
          title: "9. ආරවුල් විසඳීම",
          content: `ආරවුලක් ඇති වුවහොත්, මුලින්ම සාමකාමී විසඳුමක් සොයනු ලැබේ. එකඟතාවයකට නොපැමිණියහොත්, ආරවුල් ප්‍රංශ නීතියට සහ පැරිස් අධිකරණවල බල ප්‍රදේශයට යටත් වේ.`
        },
        {
          title: "10. සම්බන්ධතා",
          content: `${LEGAL_INFO.name}
${LEGAL_INFO.address}
ඊමේල්: ${LEGAL_INFO.email}`
        }
      ]
    }
  };

  const t = content[language] || content.en;

  return (
    <main className="pt-24 pb-16 bg-stone-50 min-h-screen" data-testid="cgv-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif text-4xl font-medium text-slate-900 mb-2">{t.title}</h1>
        <p className="text-slate-500 mb-8">{t.lastUpdate}</p>
        
        <Card className="bg-white shadow-lg">
          <CardContent className="p-8 space-y-8">
            {t.sections.map((section, index) => (
              <div key={index}>
                <h2 className="font-serif text-xl font-medium text-slate-900 mb-3">{section.title}</h2>
                <p className="text-slate-600 whitespace-pre-line leading-relaxed">{section.content}</p>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </main>
  );
};

// Mentions Légales Page
export const MentionsLegalesPage = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Legal Notice",
      lastUpdate: "Last updated: January 2026",
      sections: [
        {
          title: "1. Publisher Information",
          content: `Website: ${LEGAL_INFO.website}

Publisher:
${LEGAL_INFO.name}
Status: ${LEGAL_INFO.status}
SIRET: ${LEGAL_INFO.siret}
Address: ${LEGAL_INFO.address}
Email: ${LEGAL_INFO.email}`
        },
        {
          title: "2. Publication Director",
          content: `${LEGAL_INFO.name}
Email: ${LEGAL_INFO.email}`
        },
        {
          title: "3. Hosting",
          content: `This website is hosted by:
${LEGAL_INFO.hostName}
${LEGAL_INFO.hostAddress}`
        },
        {
          title: "4. Intellectual Property",
          content: `All content on this website (texts, images, graphics, logo, icons, etc.) is the exclusive property of ${LEGAL_INFO.name} and is protected by French and international intellectual property laws.

Any reproduction, distribution, modification, or use of the content without prior written authorization is strictly prohibited.`
        },
        {
          title: "5. Personal Data",
          content: `Personal data collected through this website is processed in accordance with the General Data Protection Regulation (GDPR) and the French Data Protection Act.

For more information, please refer to our Privacy Policy.`
        },
        {
          title: "6. Cookies",
          content: `This website uses cookies to improve user experience and analyze traffic. By continuing to browse, you accept the use of cookies in accordance with our Privacy Policy.`
        },
        {
          title: "7. Contact",
          content: `For any questions regarding this legal notice, please contact us at:
Email: ${LEGAL_INFO.email}`
        }
      ]
    },
    fr: {
      title: "Mentions Légales",
      lastUpdate: "Dernière mise à jour : Janvier 2026",
      sections: [
        {
          title: "1. Informations sur l'éditeur",
          content: `Site web : ${LEGAL_INFO.website}

Éditeur :
${LEGAL_INFO.name}
Statut : ${LEGAL_INFO.status}
SIRET : ${LEGAL_INFO.siret}
Adresse : ${LEGAL_INFO.address}
Email : ${LEGAL_INFO.email}`
        },
        {
          title: "2. Directeur de la publication",
          content: `${LEGAL_INFO.name}
Email : ${LEGAL_INFO.email}`
        },
        {
          title: "3. Hébergement",
          content: `Ce site web est hébergé par :
${LEGAL_INFO.hostName}
${LEGAL_INFO.hostAddress}`
        },
        {
          title: "4. Propriété Intellectuelle",
          content: `Tout le contenu de ce site web (textes, images, graphiques, logo, icônes, etc.) est la propriété exclusive de ${LEGAL_INFO.name} et est protégé par les lois françaises et internationales sur la propriété intellectuelle.

Toute reproduction, distribution, modification ou utilisation du contenu sans autorisation écrite préalable est strictement interdite.`
        },
        {
          title: "5. Données Personnelles",
          content: `Les données personnelles collectées via ce site web sont traitées conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.

Pour plus d'informations, veuillez consulter notre Politique de Confidentialité.`
        },
        {
          title: "6. Cookies",
          content: `Ce site web utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. En continuant à naviguer, vous acceptez l'utilisation de cookies conformément à notre Politique de Confidentialité.`
        },
        {
          title: "7. Contact",
          content: `Pour toute question concernant ces mentions légales, veuillez nous contacter à :
Email : ${LEGAL_INFO.email}`
        }
      ]
    },
    si: {
      title: "නීතිමය දැනුම්දීම",
      lastUpdate: "අවසන් යාවත්කාලීනය: ජනවාරි 2026",
      sections: [
        {
          title: "1. ප්‍රකාශක තොරතුරු",
          content: `වෙබ් අඩවිය: ${LEGAL_INFO.website}

ප්‍රකාශකයා:
${LEGAL_INFO.name}
තත්ත්වය: ${LEGAL_INFO.status}
SIRET: ${LEGAL_INFO.siret}
ලිපිනය: ${LEGAL_INFO.address}
ඊමේල්: ${LEGAL_INFO.email}`
        },
        {
          title: "2. ප්‍රකාශන අධ්‍යක්ෂ",
          content: `${LEGAL_INFO.name}
ඊමේල්: ${LEGAL_INFO.email}`
        },
        {
          title: "3. සත්කාරකත්වය",
          content: `මෙම වෙබ් අඩවිය සත්කාරකත්වය දරනුයේ:
${LEGAL_INFO.hostName}
${LEGAL_INFO.hostAddress}`
        },
        {
          title: "4. බුද්ධිමය දේපළ",
          content: `මෙම වෙබ් අඩවියේ සියලුම අන්තර්ගතය (පෙළ, පින්තූර, ග්‍රැෆික්ස්, ලාංඡනය, අයිකන, ආදිය) ${LEGAL_INFO.name} හි තනි දේපළ වන අතර ප්‍රංශ සහ ජාත්‍යන්තර බුද්ධිමය දේපළ නීති මගින් ආරක්ෂා කර ඇත.`
        },
        {
          title: "5. පුද්ගලික දත්ත",
          content: `මෙම වෙබ් අඩවිය හරහා එකතු කරන ලද පුද්ගලික දත්ත සාමාන්‍ය දත්ත ආරක්ෂණ රෙගුලාසිය (GDPR) අනුව සකසනු ලැබේ.

වැඩි විස්තර සඳහා, කරුණාකර අපගේ රහස්‍යතා ප්‍රතිපත්තිය බලන්න.`
        },
        {
          title: "6. කුකීස්",
          content: `මෙම වෙබ් අඩවිය පරිශීලක අත්දැකීම වැඩි දියුණු කිරීමට සහ ගමනාගමනය විශ්ලේෂණය කිරීමට කුකීස් භාවිතා කරයි.`
        },
        {
          title: "7. සම්බන්ධතා",
          content: `මෙම නීතිමය දැනුම්දීම පිළිබඳ ඕනෑම ප්‍රශ්නයක් සඳහා, කරුණාකර අප හා සම්බන්ධ වන්න:
ඊමේල්: ${LEGAL_INFO.email}`
        }
      ]
    }
  };

  const t = content[language] || content.en;

  return (
    <main className="pt-24 pb-16 bg-stone-50 min-h-screen" data-testid="mentions-legales-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif text-4xl font-medium text-slate-900 mb-2">{t.title}</h1>
        <p className="text-slate-500 mb-8">{t.lastUpdate}</p>
        
        <Card className="bg-white shadow-lg">
          <CardContent className="p-8 space-y-8">
            {t.sections.map((section, index) => (
              <div key={index}>
                <h2 className="font-serif text-xl font-medium text-slate-900 mb-3">{section.title}</h2>
                <p className="text-slate-600 whitespace-pre-line leading-relaxed">{section.content}</p>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </main>
  );
};

// Privacy Policy Page
export const PrivacyPolicyPage = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      title: "Privacy Policy",
      lastUpdate: "Last updated: January 2026",
      sections: [
        {
          title: "1. Data Controller",
          content: `The data controller is:
${LEGAL_INFO.name}
${LEGAL_INFO.address}
Email: ${LEGAL_INFO.email}
SIRET: ${LEGAL_INFO.siret}`
        },
        {
          title: "2. Data Collected",
          content: `We collect the following personal data:
• Identity information: Name, first name
• Contact information: Email address, phone number
• Booking information: Service type, dates, times
• Payment information: Processed securely by Stripe/PayPal (we do not store payment card details)
• Communication: Messages sent via contact form`
        },
        {
          title: "3. Purpose of Data Processing",
          content: `Your data is collected for the following purposes:
• Processing and managing your bookings
• Processing payments
• Communicating about your appointments
• Responding to your inquiries
• Sending service confirmations and reminders
• Legal compliance`
        },
        {
          title: "4. Legal Basis",
          content: `Data processing is based on:
• Contract execution: Processing bookings and providing services
• Legal obligation: Invoicing, accounting
• Legitimate interest: Improving our services
• Consent: Marketing communications (if applicable)`
        },
        {
          title: "5. Data Retention",
          content: `Your personal data is retained for:
• Client data: Duration of commercial relationship + 3 years
• Invoices: 10 years (legal requirement)
• Contact form messages: 3 years
• Cookies: Maximum 13 months`
        },
        {
          title: "6. Data Recipients",
          content: `Your data may be shared with:
• Payment providers: Stripe, PayPal (for payment processing)
• Hosting provider: Vercel (for website hosting)
• Email services (for sending confirmations)

We do not sell your personal data to third parties.`
        },
        {
          title: "7. Your Rights",
          content: `In accordance with GDPR, you have the following rights:
• Right of access: Obtain a copy of your data
• Right to rectification: Correct inaccurate data
• Right to erasure: Request deletion of your data
• Right to restriction: Limit data processing
• Right to data portability: Receive your data in a portable format
• Right to object: Object to data processing

To exercise these rights, contact us at: ${LEGAL_INFO.email}

You also have the right to lodge a complaint with the CNIL (French Data Protection Authority): www.cnil.fr`
        },
        {
          title: "8. Cookies",
          content: `Our website uses the following cookies:
• Essential cookies: Required for website functionality
• Analytics cookies: To understand how visitors use our site

You can manage your cookie preferences through your browser settings.`
        },
        {
          title: "9. Data Security",
          content: `We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. This includes:
• SSL/TLS encryption for data transmission
• Secure payment processing via Stripe/PayPal
• Limited access to personal data`
        },
        {
          title: "10. International Transfers",
          content: `Your data may be processed by service providers located outside the European Union. In such cases, we ensure appropriate safeguards are in place (Standard Contractual Clauses, adequacy decisions).`
        },
        {
          title: "11. Contact",
          content: `For any questions about this Privacy Policy or to exercise your rights:
${LEGAL_INFO.name}
Email: ${LEGAL_INFO.email}
Address: ${LEGAL_INFO.address}`
        }
      ]
    },
    fr: {
      title: "Politique de Confidentialité",
      lastUpdate: "Dernière mise à jour : Janvier 2026",
      sections: [
        {
          title: "1. Responsable du Traitement",
          content: `Le responsable du traitement est :
${LEGAL_INFO.name}
${LEGAL_INFO.address}
Email : ${LEGAL_INFO.email}
SIRET : ${LEGAL_INFO.siret}`
        },
        {
          title: "2. Données Collectées",
          content: `Nous collectons les données personnelles suivantes :
• Informations d'identité : Nom, prénom
• Coordonnées : Adresse email, numéro de téléphone
• Informations de réservation : Type de service, dates, heures
• Informations de paiement : Traitées de manière sécurisée par Stripe/PayPal (nous ne stockons pas les détails de carte bancaire)
• Communications : Messages envoyés via le formulaire de contact`
        },
        {
          title: "3. Finalités du Traitement",
          content: `Vos données sont collectées pour les finalités suivantes :
• Traitement et gestion de vos réservations
• Traitement des paiements
• Communication concernant vos rendez-vous
• Réponse à vos demandes
• Envoi de confirmations et rappels de service
• Conformité légale`
        },
        {
          title: "4. Base Légale",
          content: `Le traitement des données est fondé sur :
• Exécution du contrat : Traitement des réservations et fourniture des services
• Obligation légale : Facturation, comptabilité
• Intérêt légitime : Amélioration de nos services
• Consentement : Communications marketing (le cas échéant)`
        },
        {
          title: "5. Durée de Conservation",
          content: `Vos données personnelles sont conservées pendant :
• Données clients : Durée de la relation commerciale + 3 ans
• Factures : 10 ans (obligation légale)
• Messages du formulaire de contact : 3 ans
• Cookies : Maximum 13 mois`
        },
        {
          title: "6. Destinataires des Données",
          content: `Vos données peuvent être partagées avec :
• Prestataires de paiement : Stripe, PayPal (pour le traitement des paiements)
• Hébergeur : Vercel (pour l'hébergement du site)
• Services d'email (pour l'envoi de confirmations)

Nous ne vendons pas vos données personnelles à des tiers.`
        },
        {
          title: "7. Vos Droits",
          content: `Conformément au RGPD, vous disposez des droits suivants :
• Droit d'accès : Obtenir une copie de vos données
• Droit de rectification : Corriger des données inexactes
• Droit à l'effacement : Demander la suppression de vos données
• Droit à la limitation : Limiter le traitement des données
• Droit à la portabilité : Recevoir vos données dans un format portable
• Droit d'opposition : S'opposer au traitement des données

Pour exercer ces droits, contactez-nous à : ${LEGAL_INFO.email}

Vous avez également le droit de déposer une réclamation auprès de la CNIL : www.cnil.fr`
        },
        {
          title: "8. Cookies",
          content: `Notre site web utilise les cookies suivants :
• Cookies essentiels : Nécessaires au fonctionnement du site
• Cookies analytiques : Pour comprendre comment les visiteurs utilisent notre site

Vous pouvez gérer vos préférences de cookies via les paramètres de votre navigateur.`
        },
        {
          title: "9. Sécurité des Données",
          content: `Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction. Cela inclut :
• Chiffrement SSL/TLS pour la transmission des données
• Traitement sécurisé des paiements via Stripe/PayPal
• Accès limité aux données personnelles`
        },
        {
          title: "10. Transferts Internationaux",
          content: `Vos données peuvent être traitées par des prestataires situés en dehors de l'Union Européenne. Dans ce cas, nous nous assurons que des garanties appropriées sont en place (Clauses Contractuelles Types, décisions d'adéquation).`
        },
        {
          title: "11. Contact",
          content: `Pour toute question concernant cette Politique de Confidentialité ou pour exercer vos droits :
${LEGAL_INFO.name}
Email : ${LEGAL_INFO.email}
Adresse : ${LEGAL_INFO.address}`
        }
      ]
    },
    si: {
      title: "රහස්‍යතා ප්‍රතිපත්තිය",
      lastUpdate: "අවසන් යාවත්කාලීනය: ජනවාරි 2026",
      sections: [
        {
          title: "1. දත්ත පාලක",
          content: `දත්ත පාලකයා:
${LEGAL_INFO.name}
${LEGAL_INFO.address}
ඊමේල්: ${LEGAL_INFO.email}
SIRET: ${LEGAL_INFO.siret}`
        },
        {
          title: "2. එකතු කරන දත්ත",
          content: `අපි පහත පුද්ගලික දත්ත එකතු කරමු:
• අනන්‍යතා තොරතුරු: නම
• සම්බන්ධතා තොරතුරු: ඊමේල් ලිපිනය, දුරකථන අංකය
• වෙන්කිරීම් තොරතුරු: සේවා වර්ගය, දිනයන්, වේලාවන්
• ගෙවීම් තොරතුරු: Stripe/PayPal මගින් ආරක්ෂිතව සකසනු ලැබේ
• සන්නිවේදනය: සම්බන්ධතා පෝරමය හරහා යවන පණිවිඩ`
        },
        {
          title: "3. දත්ත සැකසීමේ අරමුණ",
          content: `ඔබේ දත්ත පහත අරමුණු සඳහා එකතු කරනු ලැබේ:
• ඔබේ වෙන්කිරීම් සැකසීම සහ කළමනාකරණය
• ගෙවීම් සැකසීම
• ඔබේ හමුවීම් පිළිබඳ සන්නිවේදනය
• ඔබේ විමසීම්වලට ප්‍රතිචාර දැක්වීම
• සේවා තහවුරු කිරීම් සහ මතක් කිරීම් යැවීම`
        },
        {
          title: "4. නීතිමය පදනම",
          content: `දත්ත සැකසීම පදනම් වන්නේ:
• ගිවිසුම් ක්‍රියාත්මක කිරීම
• නීතිමය බැඳීම
• නීත්‍යානුකූල උනන්දුව
• කැමැත්ත`
        },
        {
          title: "5. දත්ත රඳවා තබා ගැනීම",
          content: `ඔබේ පුද්ගලික දත්ත රඳවා තබා ගන්නේ:
• සේවාදායක දත්ත: වාණිජ සම්බන්ධතාවයේ කාලය + වසර 3
• ඉන්වොයිස්: වසර 10 (නීතිමය අවශ්‍යතාව)
• සම්බන්ධතා පෝරම පණිවිඩ: වසර 3
• කුකීස්: උපරිම මාස 13`
        },
        {
          title: "6. දත්ත ලබන්නන්",
          content: `ඔබේ දත්ත බෙදාගත හැක්කේ:
• ගෙවීම් සපයන්නන්: Stripe, PayPal
• සත්කාරක සපයන්නා: Vercel
• ඊමේල් සේවා

අපි ඔබේ පුද්ගලික දත්ත තෙවන පාර්ශ්වයන්ට විකුණන්නේ නැත.`
        },
        {
          title: "7. ඔබේ අයිතිවාසිකම්",
          content: `GDPR අනුව, ඔබට පහත අයිතිවාසිකම් ඇත:
• ප්‍රවේශ අයිතිය
• නිවැරදි කිරීමේ අයිතිය
• මකා දැමීමේ අයිතිය
• සීමා කිරීමේ අයිතිය
• දත්ත අතේ ගෙන යා හැකි බව
• විරෝධ දැක්වීමේ අයිතිය

මෙම අයිතිවාසිකම් භාවිතා කිරීමට, අප හා සම්බන්ධ වන්න: ${LEGAL_INFO.email}`
        },
        {
          title: "8. කුකීස්",
          content: `අපගේ වෙබ් අඩවිය පහත කුකීස් භාවිතා කරයි:
• අත්‍යවශ්‍ය කුකීස්: වෙබ් අඩවි ක්‍රියාකාරිත්වය සඳහා අවශ්‍යයි
• විශ්ලේෂණ කුකීස්: අමුත්තන් අපගේ අඩවිය භාවිතා කරන ආකාරය තේරුම් ගැනීමට`
        },
        {
          title: "9. දත්ත ආරක්ෂාව",
          content: `අනවසර ප්‍රවේශය, වෙනස් කිරීම, හෙළිදරව් කිරීම හෝ විනාශ කිරීමෙන් ඔබේ පුද්ගලික දත්ත ආරක්ෂා කිරීම සඳහා අපි සුදුසු තාක්ෂණික සහ සංවිධානාත්මක පියවර ක්‍රියාත්මක කරමු.`
        },
        {
          title: "10. ජාත්‍යන්තර මාරු කිරීම්",
          content: `ඔබේ දත්ත යුරෝපීය සංගමයෙන් පිටත පිහිටි සේවා සපයන්නන් විසින් සැකසිය හැක. එවැනි අවස්ථාවලදී, සුදුසු ආරක්ෂාවන් පවතින බව අපි සහතික කරමු.`
        },
        {
          title: "11. සම්බන්ධතා",
          content: `මෙම රහස්‍යතා ප්‍රතිපත්තිය පිළිබඳ ඕනෑම ප්‍රශ්නයක් සඳහා:
${LEGAL_INFO.name}
ඊමේල්: ${LEGAL_INFO.email}
ලිපිනය: ${LEGAL_INFO.address}`
        }
      ]
    }
  };

  const t = content[language] || content.en;

  return (
    <main className="pt-24 pb-16 bg-stone-50 min-h-screen" data-testid="privacy-policy-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif text-4xl font-medium text-slate-900 mb-2">{t.title}</h1>
        <p className="text-slate-500 mb-8">{t.lastUpdate}</p>
        
        <Card className="bg-white shadow-lg">
          <CardContent className="p-8 space-y-8">
            {t.sections.map((section, index) => (
              <div key={index}>
                <h2 className="font-serif text-xl font-medium text-slate-900 mb-3">{section.title}</h2>
                <p className="text-slate-600 whitespace-pre-line leading-relaxed">{section.content}</p>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </main>
  );
};
